import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import DialogPlugin from './plugins/dialog'
import Toast from './components/Toast.vue'
import ConfirmDialog from './components/ConfirmDialog.vue'

Vue.config.productionTip = false
Vue.use(DialogPlugin)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
